import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationBulkActivateAtom = createMutationAtomFactory(
  'automations.bulkActivate',
  (params: { ids: string[] }) => ({
    automationsAutomationBulkActivate: {
      __args: {
        input: { ids: params.ids },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
);
